import { VariantsStyle } from "./toggle.type";

const variants: VariantsStyle = {
	default: {
		backgroundColor: "toggle-default-bg-color",
		color: "toggle-default-color",
	},
	info: {
		backgroundColor: "toggle-info-bg-color",
		color: "toggle-info-color",
	},
	warning: {
		backgroundColor: "secondary-orange",
		color: "primary-white",
	},
	success: {
		backgroundColor: "secondary-green",
		color: "primary-white",
	},
	error: {
		backgroundColor: "primary-red",
		color: "primary-white",
	},
};

export default variants;
